import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 4.935c3.784 0 6.56.696 7.41 1.012a.835.835 0 1 0 .58-1.565c-1.059-.394-4.035-1.117-7.99-1.117a.835.835 0 1 0 0 1.67m7.7 2.33a.835.835 0 0 0-.835.835v3.565h-1.582a4.39 4.39 0 0 0-.924-1.962C13.523 8.699 12.135 7.985 10 7.985a.835.835 0 1 0 0 1.67c1.734 0 2.613.562 3.076 1.117.49.588.621 1.299.621 1.728 0 .461.374.835.836.835H17.7a.835.835 0 0 0 .835-.835V8.1a.835.835 0 0 0-.835-.835",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10 4.935c-3.784 0-6.56.696-7.41 1.012a.835.835 0 1 1-.58-1.565C3.068 3.988 6.044 3.265 10 3.265a.835.835 0 0 1 0 1.67m-7.7 2.33c.461 0 .835.374.835.835v3.565h1.582c.121-.61.39-1.32.924-1.962C6.478 8.699 7.865 7.985 10 7.985a.835.835 0 0 1 0 1.67c-1.734 0-2.613.562-3.076 1.117a2.793 2.793 0 0 0-.621 1.728.835.835 0 0 1-.835.835H2.3a.835.835 0 0 1-.835-.835V8.1c0-.461.374-.835.835-.835M8.556 16.042c-.532.274-1.156.593-2.32.593a7.5 7.5 0 0 1-2.18-.29l-.011-.003A5.847 5.847 0 0 0 2.3 16.11a.835.835 0 0 1 0-1.67c1.07 0 1.647.15 2.18.29l.01.003c.463.121.885.232 1.746.232.766 0 1.11-.178 1.542-.4l.012-.007c.532-.274 1.157-.593 2.32-.593 1.165 0 1.79.319 2.321.593l.013.006c.43.223.775.401 1.541.401.855 0 1.244-.109 1.668-.227l.015-.005c.51-.142 1.06-.293 2.132-.293a.835.835 0 0 1 0 1.67c-.854 0-1.244.109-1.667.227l-.015.005c-.51.142-1.06.293-2.132.293-1.165 0-1.79-.319-2.321-.593l-.012-.007c-.432-.222-.776-.4-1.543-.4-.766 0-1.11.178-1.541.4z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }